<template>
  <sub-page title="培训证书查询">
    <div class="query-page">
      <!-- 用户信息 -->
      <div class="user-card">
        <div class="avatar">
          <svg viewBox="0 0 24 24" class="avatar-icon"><circle cx="12" cy="8" r="4" fill="#c8c9cc"/><path d="M4 20 C4 15 8 13 12 13 C16 13 20 15 20 20 Z" fill="#c8c9cc"/></svg>
        </div>
        <div class="user-info">
          <div class="user-name">戴义杰</div>
          <div class="user-id">3411**********5619</div>
        </div>
      </div>

      <div class="result-text">共查询到 1 条证书记录</div>

      <!-- 证书卡片 -->
      <div class="cert-card">
        <div class="cert-head">
          <div class="cert-badge">
            <svg viewBox="0 0 24 24" class="badge-icon"><circle cx="12" cy="9" r="6" fill="none" stroke="#D88230" stroke-width="2"/><path d="M9 14 L7.5 21 L12 18.5 L16.5 21 L15 14 Z" fill="none" stroke="#D88230" stroke-width="2" stroke-linejoin="round"/></svg>
          </div>
          <div class="cert-name">职业技能等级证书</div>
          <span class="cert-level">四级 / 中级工</span>
        </div>
        <div class="cert-body">
          <div class="info-item"><span class="label">证书编号</span><span class="value">S05820260800362</span></div>
          <div class="info-item"><span class="label">职业（工种）</span><span class="value">半导体芯片制造工</span></div>
          <div class="info-item"><span class="label">证书等级</span><span class="value">四级</span></div>
          <div class="info-item"><span class="label">发证日期</span><span class="value">2026-08-20</span></div>
          <div class="info-item"><span class="label">发证机关</span><span class="value">南京市人力资源和社会保障局</span></div>
          <div class="info-item"><span class="label">评价机构</span><span class="value">江苏超芯星半导体有限公司</span></div>
          <div class="info-item"><span class="label">证书状态</span><span class="value txt-green">有效</span></div>
        </div>
        <div class="cert-actions">
          <button class="action-btn primary" @click="viewCert">查看证书</button>
          <button class="action-btn" @click="applySubsidy">申领获证补贴</button>
        </div>
      </div>

      <!-- 职位推荐悬浮按钮 -->
      <div class="float-btn" @click="goJobRecommend">职位推荐</div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'TrainingCertQuery',
  components: { SubPage },
  methods: {
    viewCert() {
      this.$alert('电子证书查验成功：证书编号 S05820260800362，半导体芯片制造工（四级），状态有效')
    },
    applySubsidy() {
      this.$router.push('/training-subsidy')
    },
    goJobRecommend() {
      this.$alert('根据您的证书（半导体芯片制造工·四级），已为您推荐 3 个匹配岗位，可在「职位推荐」服务中查看')
    }
  }
}
</script>

<style scoped>
.query-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.user-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: calc(32 * var(--w));
  gap: calc(24 * var(--w));
  margin-bottom: calc(16 * var(--w));
}
.avatar {
  width: calc(100 * var(--w));
  height: calc(100 * var(--w));
  border-radius: 50%;
  background: #f2f2f2;
  overflow: hidden;
  flex-shrink: 0;
}
.avatar-icon {
  width: 100%;
  height: 100%;
}
.user-name {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  margin-bottom: calc(8 * var(--w));
}
.user-id {
  font-size: calc(28 * var(--w));
  color: #646566;
}
.result-text {
  font-size: calc(28 * var(--w));
  color: #646566;
  padding: calc(16 * var(--w)) calc(32 * var(--w));
}
.cert-card {
  background: #fff;
  border-radius: calc(12 * var(--w));
  margin: 0 calc(24 * var(--w));
  overflow: hidden;
}
.cert-head {
  background: linear-gradient(135deg, #ff976a, #D88230);
  padding: calc(36 * var(--w)) calc(32 * var(--w));
  display: flex;
  align-items: center;
  gap: calc(20 * var(--w));
}
.cert-badge {
  width: calc(72 * var(--w));
  height: calc(72 * var(--w));
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.badge-icon {
  width: calc(44 * var(--w));
  height: calc(44 * var(--w));
}
.cert-name {
  flex: 1;
  font-size: calc(34 * var(--w));
  font-weight: bold;
  color: #fff;
}
.cert-level {
  font-size: calc(24 * var(--w));
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: calc(8 * var(--w));
  padding: calc(4 * var(--w)) calc(16 * var(--w));
}
.cert-body {
  padding: calc(12 * var(--w)) calc(32 * var(--w));
}
.info-item {
  display: flex;
  align-items: center;
  min-height: calc(88 * var(--w));
  border-bottom: 1px solid #f5f5f5;
  font-size: calc(28 * var(--w));
}
.info-item:last-child {
  border-bottom: none;
}
.label {
  color: #969799;
  width: calc(220 * var(--w));
  flex-shrink: 0;
}
.value {
  flex: 1;
  color: #323233;
  text-align: right;
}
.txt-green {
  color: #07A35A;
  font-weight: bold;
}
.cert-actions {
  display: flex;
  gap: calc(24 * var(--w));
  padding: calc(24 * var(--w)) calc(32 * var(--w)) calc(32 * var(--w));
}
.action-btn {
  flex: 1;
  height: calc(80 * var(--w));
  background: #fff;
  color: #2E8CF6;
  border: 1px solid #2E8CF6;
  border-radius: calc(8 * var(--w));
  font-size: calc(30 * var(--w));
  cursor: pointer;
}
.action-btn.primary {
  background: #2E8CF6;
  color: #fff;
}
.float-btn {
  position: fixed;
  right: calc(32 * var(--w));
  bottom: calc(80 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(26 * var(--w));
  padding: calc(16 * var(--w)) calc(28 * var(--w));
  border-radius: calc(40 * var(--w));
  box-shadow: 0 calc(4 * var(--w)) calc(16 * var(--w)) rgba(46, 140, 246, 0.4);
  cursor: pointer;
  z-index: 50;
}
</style>



// WEBPACK FOOTER //
// src/pages/TrainingCertQuery.vue